export default class SvgShape {
	constructor(holder, options) {
		this.holder = holder;

		this.options = Object.assign({
			svg: 'svg',
			table: 'table',
			flat: 'data-flat',
			floor: 'data-floor',
			building: 'data-building',
			activeClass: 'active',
			moveTopClass: 'toTop',
			dataCol: 'data-col',
		}, options);

		this.init();
	}

	init() {
		this.findElements();
		this.attachEvents();
		this.addDisabledFlats();
	}

	findElements() {
		this.rowParams = {};
		this.svg = this.holder.querySelector(this.options.svg);
		this.table = this.holder.querySelector(this.options.table);
		this.flats = this.holder.querySelectorAll(`[${this.options.flat}]`);
		this.floors = this.holder.querySelectorAll(`[${this.options.floor}]`);
		this.table.querySelectorAll('th').forEach((it, i) => this.rowParams[i] = it.getAttribute(this.options.dataCol));
	}

	attachEvents() {
		const events = ['mouseenter', 'touchstart'];

		events.forEach((event) => {
			this.flats.forEach((el) => el.addEventListener(event, flatMouseenterHandler.bind(this, el)));
			this.floors.forEach((el) => el.addEventListener(event, floorMouseenterHandler.bind(this, el)));
		});

		function flatMouseenterHandler(curEl) {
			const flatID = `[${this.options.flat}='${curEl.getAttribute(this.options.flat)}']`;
			const flatRow = this.holder.querySelectorAll(flatID);

			this.toggleActiveClass(flatRow, true);

			const flat = this.svg.querySelector(flatID);

			if (flat) {
				const floor = flat.closest(`[${this.options.floor}]`);

				if (floor) {
					this.moveFloors(floor);
				}
			}
		}

		function floorMouseenterHandler(curEl) {
			this.moveFloors(curEl);
		}
	}

	addDisabledFlats() {
		this.table.querySelectorAll('[data-status="disable"]').forEach((it) => {
			const svgFlat = this.svg.querySelector(`[${this.options.flat}="${it.getAttribute(this.options.flat)}"]`);

			svgFlat.setAttribute('data-status', 'disable');
		});
	}

	toggleActiveClass(curFlats) {
		this.flats.forEach((flat) => flat.classList.remove(this.options.activeClass));
		curFlats.forEach((flat) => flat.classList.add(this.options.activeClass));
	}

	moveFloors(cur) {
		const building = cur.closest(`[${this.options.building}]`);
		const floors = building.querySelectorAll(`[${this.options.floor}]`);
		const floorInd = +cur.getAttribute(this.options.floor);

		this.floors.forEach((floor) => floor.classList.remove(this.options.moveTopClass));

		if (floorInd < floors.length - 1) {
			floors.forEach((floor, ind) => {
				if (ind > floorInd) floor.classList.add(this.options.moveTopClass);
			});
		}
	}
}